import _get from 'lodash/get';

import { SharedState } from '../redux/reducer';

const suggestSelector = (state: unknown) => {
  const {
    suggests: {
      data: suggests = [],
      statuses: { loading: isSuggestLoading },
    },
    popular: { data: popularDestinations = [], loading: isPopularDestinationsLoading },
  } = _get(state, 'hotels.searchForm') as SharedState;

  const isLoading = isSuggestLoading || isPopularDestinationsLoading;
  const hasPopularDestinations = popularDestinations.length > 0;

  if (suggests.length > 0) {
    return {
      list: suggests || [],
      isLoading,
      hasPopularDestinations,
    };
  }

  return {
    list: popularDestinations,
    isLoading,
    hasPopularDestinations,
  };
};

export default suggestSelector;
